import PictureTextElementTile from "./picture_text_grid_tile";
import GenericTrackingService from "./generic_tracking_service"
import {PictureTextType, TrackingWidgetTile} from "./types";

export default class PictureTextGrid {
    readonly featureOrder: number;
    readonly filledSlots: number;
    readonly featureIndex: number;
    readonly featureId: string;
    readonly parentFeatureId: string;
    readonly masFeatureTrackingLabels: { [key: string]: string[] } = {};
    readonly trackingWidgetTiles: TrackingWidgetTile[];
    private readonly trackingService: GenericTrackingService;

    constructor(container: Element) {

        this.featureOrder = this.getFeatureOrder(container);
        this.featureIndex = this.getFeatureIndex(container);
        this.featureId = this.getDataFeatureId(container)
        this.masFeatureTrackingLabels = this._getMasFeatureTrackingLabels(container);
        this.parentFeatureId = this.getParentFeatureTrackingId(this.featureId);
        const pictureTextTileGridDoms = container.querySelectorAll('.promo_staticcontent--picture-text-grid-widget-grid-element');
        this.trackingWidgetTiles = Array
            .from(pictureTextTileGridDoms)
            .map((tileDom: Element, index: number) => new PictureTextElementTile(tileDom, index + 1))
            .map(pictureTextElementTile => this.convertToTrackingWidgetTile(pictureTextElementTile))

        this.filledSlots = this.trackingWidgetTiles.length;
        this.trackingService = new GenericTrackingService();
        this.trackLoaded(container);
        this.registerScrollTrackingObserver(pictureTextTileGridDoms);


        pictureTextTileGridDoms.forEach((bildTextTileDom: Element, index: number) => {
            bildTextTileDom.addEventListener("click", this.trackClick(this.trackingWidgetTiles[index], "Grid"), false);
        });
    }

    trackClick(trackingWidgetTile: TrackingWidgetTile, tileType: PictureTextType): () => void {
        const self = this;
        return function () {
            self.trackingService.sendClickTrackingEvent(self.featureOrder, self.featureIndex, self.parentFeatureId, trackingWidgetTile, self.filledSlots, self.masFeatureTrackingLabels, tileType);
        }
    }

    registerScrollTrackingObserver(pictureTextTileDoms: NodeListOf<Element>): void {
        /*                                     */
        const trackingObserver = new IntersectionObserver((entries) => {
            const entriesToTrack = entries
                .filter((entry) => entry.isIntersecting);

            if (entriesToTrack.length > 0) {
                const positionsToTrack = entriesToTrack
                    .map((entry) => this.getTileFeatureTrackingId(this.featureId, parseInt(entry.target.getAttribute("data-tile-position")!)))

                this.trackingService.sendScrollTrackingEvent(this.parentFeatureId, positionsToTrack);

                entriesToTrack.forEach((entry) => {
                    trackingObserver.unobserve(entry.target);
                });
            }

        });
        pictureTextTileDoms.forEach((card) => {
            trackingObserver.observe(card);
        });
    }

    private getFeatureOrder(container: Element): number {
        const dataFeatureOrder = container.closest('[data-feature-order]')?.getAttribute('data-feature-order');
        return dataFeatureOrder ? parseInt(dataFeatureOrder, 0) : -1;
    }

    private getFeatureIndex(container: Element): number {
        return parseInt(container.getAttribute('data-feature-index')!, 0);
    }

    private getDataFeatureId(container: Element): string {
        return container.getAttribute('data-feature-id')!;
    }

    _getMasFeatureTrackingLabels(container: Element) {
        const dataFeatureTrackingLabels = container.closest('[data-feature-tracking-labels]')?.getAttribute("data-feature-tracking-labels");
        return dataFeatureTrackingLabels ? JSON.parse(dataFeatureTrackingLabels) : {};
    }

    private trackLoaded(container: Element) {
        if (!container.getAttribute("data-tracked")) {
            container.setAttribute("data-tracked", "true");
            this.trackingService.sendLoadedTracking(
                this.featureOrder,
                this.featureIndex,
                this.parentFeatureId,
                this.trackingWidgetTiles,
                this.masFeatureTrackingLabels,
                "Grid");
        }
    }

    private getParentFeatureTrackingId(featureId: string) {
        return `ft3_ptg_${featureId}`;
    }

    private getTileFeatureTrackingId(featureId: string, tilePosition: number) {
        return `ft3_ptg_${featureId}_tile${tilePosition}`;
    }

    private convertToTrackingWidgetTile(pictureTextElementTile: PictureTextElementTile): TrackingWidgetTile {
        return {
            id: this.getTileFeatureTrackingId(this.featureId, pictureTextElementTile.position),
            position: pictureTextElementTile.position,
            labels: {
                promo_Content: [pictureTextElementTile.subline],
                promo_Source: ["manual"],
            }
        }
    }
}